import React from "react";
import { FormattedMessage } from "react-intl";

export const PaginationTotalRenderer = (from, to, size) => (
  <span className="react-bootstrap-table-pagination-total text-dark font-size-lg">
    <FormattedMessage
      id="COMMON.GENERAL.PAGINATION.RESULTS"
      values={{ from, to, size }}
    />
  </span>
);
